module.exports = __webpack_public_path__ + "img/hotel-7.b536868e.jpeg";